export default {
  // Inventory
  "no_films_found": "未找到匹配的胶片",
  "no_films_yet": "您还没有任何胶卷",
  "add_first_film": "添加您的第一个胶片",
  "no_lenses_found": "未找到匹配的镜头",
  "no_lenses_yet": "您还没有任何镜头",
  "add_first_lens": "添加您的第一个镜头",
  "no_cameras_found": "未找到匹配的相机",
  "no_cameras_yet": "您还没有任何相机",
  "add_first_camera": "添加您的第一台相机",
  "no_items_inventory": "您的库存中没有物品",
  "inventory_management": "库存管理",
  "film": "胶片",
  "cameras": "相机",
  "lenses": "镜头",
  "search_films": "搜索胶片...",
  "search_lenses": "搜索镜头...",
  "search_cameras": "搜索相机...",
  "add_lens": "添加镜头",
  "add_film": "添加胶片",
  "add_camera": "添加相机",
  "add_new_lens": "添加新镜头",
  "add_new_film": "添加新胶片",
  "add_new_camera": "添加新相机",
  "add_lens_details": "填写以下详细信息以将新镜头添加到您的库存中。",
  "add_film_details": "填写以下详细信息以将新胶片添加到您的库存中。",
  "add_camera_details": "填写以下详细信息以将新相机添加到您的库存中。",
  "essential_info": "基本信息",
  "optional_details": "可选详情",
  "brand": "品牌",
  "lens_name": "镜头名称/型号",
  "lens_name_placeholder": "50mm f/1.8, 24-70mm f/2.8等",
  "brand_placeholder": "尼康、佳能等",
  "film_name": "胶片名称",
  "film_name_placeholder": "Portra 400, HP5 Plus等",
  "camera_name": "相机名称/型号",
  "camera_name_placeholder": "AE-1, F3, Leica M6等",
  "mount": "接口",
  "mount_placeholder": "例如 EF、M42",
  "mount_description": "最多4个字母数字字符（例如，EF、M42）",
  "status": "状态",
  "select_status": "选择状态",
  "working": "正常工作",
  "needs_repair": "需要修理",
  "for_parts": "用作零件",
  "serial_number": "序列号（可选）",
  "purchase_date": "购买日期（可选）",
  "purchase_price": "购买价格（可选）",
  "notes": "备注（可选）",
  "notes_placeholder": "关于此物品的任何其他备注",
  "next_step": "下一步",
  "update_lens": "更新镜头",
  "update_film": "更新胶片",
  "update_camera": "更新相机",
  "edit_film": "编辑胶片",
  "edit_lens": "编辑镜头",
  "edit_camera": "编辑相机",
  "update_film_details": "在下方更新您的胶片详情",
  "update_lens_details": "在下方更新您的镜头详情",
  "update_camera_details": "在下方更新您的相机详情",
  "delete_film": "删除胶片",
  "delete_lens": "删除镜头",
  "delete_camera": "删除相机",
  "confirm_delete_film": "您确定要删除",
  "confirm_delete_lens": "您确定要删除",
  "confirm_delete_camera": "您确定要删除",
  "from_your_inventory": "从您的库存中",
  "action_cannot_undone": "此操作无法撤销。",
  "film_removed_inventory": "胶片已从库存中移除",
  "lens_removed_inventory": "镜头已从库存中移除",
  "camera_removed_inventory": "相机已从库存中移除",
  "failed_delete_film": "删除胶片失败",
  "failed_delete_lens": "删除镜头失败",
  "failed_delete_camera": "删除相机失败",
  "cannot_delete_film_missing_id": "无法删除胶片，缺少ID",
  "cannot_delete_lens_missing_id": "无法删除镜头，缺少ID",
  "cannot_delete_camera_missing_id": "无法删除相机，缺少ID",
  "film_updated_successfully": "胶片更新成功",
  "lens_updated_successfully": "镜头更新成功",
  "camera_updated_successfully": "相机更新成功",
  "error_updating_film": "更新胶片时出错",
  "error_updating_lens": "更新镜头时出错",
  "error_updating_camera": "更新相机时出错",
  "cannot_update_film_missing_id": "无法更新胶片，缺少ID",
  "cannot_update_lens_missing_id": "无法更新镜头，缺少ID",
  "cannot_update_camera_missing_id": "无法更新相机，缺少ID",
  "all": "全部",
  "all_film": "所有胶片",
  "all_lenses": "所有镜头",
  "all_cameras": "所有相机",
  "unexposed": "未曝光",
  "fresh": "新品",
  "exposed": "已曝光",
  "expired": "已过期",
  "developed": "已冲洗",
  "transferring": "转移中：",
  "quantity_expose": "要曝光的数量",
  "notes_optional": "备注（可选）",
  "mark_exposed": "标记为已曝光",
  "mark_film_exposed": "将胶片标记为已曝光",
  "transfer_film_description": "将胶片从您的库存转移到已曝光集合。",
  "signin_required_inventory": "您必须登录才能查看您的库存",
  "film_details": "胶片详情",
  "lens_details": "镜头详情",
  "camera_details": "相机详情",
  "last_updated": "最后更新",
  "type": "类型",
  "quantity": "数量",
  "expiration_date": "过期日期",
  "expiration": "过期",
  "focal_length": "焦距",
  "aperture": "光圈",
  "iso": "ISO",
  "film_type": "胶片类型",
  "color": "彩色",
  "black_and_white": "黑白",
  "slide": "幻灯片",
  "camera_type": "相机类型",
  "slr": "单反",
  "dslr": "数码单反",
  "mirrorless": "无反光镜",
  "rangefinder": "测距仪",
  "point_and_shoot": "傻瓜相机",
  "instant_film": "即时成像",
  "adapter_enabled": "启用适配器",
  "adapter_mounts": "适配器接口",
  "are_you_absolutely_sure": "您确定要这样做吗？",
  "select_format": "选择格式",
  "select_camera_type": "选择相机类型",
  "error_loading_cameras": "加载相机时出错",
  "camera_added_successfully": "相机添加成功",
  "error_adding_camera": "添加相机时出错",
  "model": "型号",
  "format": "格式",
  "medium_format": "中画幅",
  "large_format": "大画幅",
};
